module.exports = __webpack_public_path__ + "static/media/warranty.2f20d94b.png";